(function () {
  if (window.__productScrollSmoothingRuntimeLoaded) return;
  window.__productScrollSmoothingRuntimeLoaded = true;

  const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

  class ProductScrollSmoothing {
    constructor(section) {
      this.position = window.scrollY;
      this.target = this.position;
      this.frame = 0;
      this.lastTime = 0;
      this.writingScroll = false;
      this.desktopQuery = window.matchMedia('(min-width: 990px) and (pointer: fine)');
      this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onWheel = this.onWheel.bind(this);
      this.onNativeScroll = this.onNativeScroll.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onPreferenceChange = this.onPreferenceChange.bind(this);
      this.animate = this.animate.bind(this);
      this.updateOptions(section);

      window.addEventListener('scroll', this.onNativeScroll, { passive: true });
      window.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      window.addEventListener('keydown', this.onKeyDown);
      this.desktopQuery.addEventListener?.('change', this.onPreferenceChange);
      this.reduceMotionQuery.addEventListener?.('change', this.onPreferenceChange);
      this.onPreferenceChange();
    }

    updateOptions(section) {
      this.speed = clamp(Number(section?.dataset.routeScrollSpeed || .68), .2, 1);
      this.follow = clamp(Number(section?.dataset.routeScrollFollow || 220), 80, 500);
    }

    get enabled() {
      return this.desktopQuery.matches && !this.reduceMotionQuery.matches;
    }

    onPreferenceChange() {
      window.removeEventListener('wheel', this.onWheel);
      this.stop();
      this.sync();
      if (this.enabled) window.addEventListener('wheel', this.onWheel, { passive: false });
    }

    onWheel(event) {
      if (
        !this.enabled ||
        event.defaultPrevented ||
        event.ctrlKey ||
        event.deltaY === 0 ||
        Math.abs(event.deltaX) > Math.abs(event.deltaY) ||
        this.shouldUseNativeScroll(event.target, event.deltaY)
      ) return;

      event.preventDefault();
      if (!this.frame) this.sync();
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? window.innerHeight : 1;
      this.target = this.clampScroll(this.target + event.deltaY * unit * this.speed);
      this.start();
    }

    shouldUseNativeScroll(target, deltaY) {
      if (!(target instanceof Element)) return false;
      if (target.closest('input, textarea, select, [contenteditable="true"]')) return true;
      if (getComputedStyle(document.body).overflowY === 'hidden') return true;

      let element = target;
      while (element && element !== document.body) {
        const style = getComputedStyle(element);
        const canScroll = /(auto|scroll)/.test(style.overflowY) && element.scrollHeight > element.clientHeight + 1;
        if (canScroll) {
          const hasRoom = deltaY > 0
            ? element.scrollTop + element.clientHeight < element.scrollHeight - 1
            : element.scrollTop > 1;
          if (hasRoom) return true;
        }
        element = element.parentElement;
      }
      return false;
    }

    onNativeScroll() {
      if (!this.writingScroll && !this.frame) this.sync();
    }

    onPointerDown() {
      if (!this.frame) return;
      this.stop();
      requestAnimationFrame(() => this.sync());
    }

    onKeyDown(event) {
      if (!['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) return;
      this.stop();
      requestAnimationFrame(() => this.sync());
    }

    start() {
      if (this.frame) return;
      this.lastTime = 0;
      this.frame = requestAnimationFrame(this.animate);
    }

    animate(time) {
      const deltaTime = this.lastTime ? Math.min(48, time - this.lastTime) : 16;
      const blend = 1 - Math.exp(-deltaTime / this.follow);
      const difference = this.target - this.position;
      this.lastTime = time;

      if (Math.abs(difference) < .35) {
        this.position = this.target;
        this.writeScroll();
        this.stop();
        return;
      }

      this.position += difference * blend;
      this.writeScroll();
      this.frame = requestAnimationFrame(this.animate);
    }

    writeScroll() {
      this.writingScroll = true;
      window.scrollTo(0, this.position);
      this.writingScroll = false;
    }

    sync() {
      this.position = window.scrollY;
      this.target = this.position;
    }

    stop() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = 0;
    }

    clampScroll(value) {
      const maximum = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      return clamp(value, 0, maximum);
    }

    destroy() {
      this.stop();
      window.removeEventListener('wheel', this.onWheel);
      window.removeEventListener('scroll', this.onNativeScroll);
      window.removeEventListener('pointerdown', this.onPointerDown);
      window.removeEventListener('keydown', this.onKeyDown);
      this.desktopQuery.removeEventListener?.('change', this.onPreferenceChange);
      this.reduceMotionQuery.removeEventListener?.('change', this.onPreferenceChange);
    }
  }

  function sync() {
    const section = document.querySelector('[data-scroll-route-section][data-route-smooth-scroll="true"]');
    if (section) {
      if (window.__productScrollSmoothing) window.__productScrollSmoothing.updateOptions(section);
      else window.__productScrollSmoothing = new ProductScrollSmoothing(section);
      return;
    }

    window.__productScrollSmoothing?.destroy();
    window.__productScrollSmoothing = null;
  }

  sync();
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(sync));
})();
